import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import instance from './http'

Vue.prototype.$axios = instance
Vue.config.productionTip = false
Vue.use(ElementUI);

ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.MessageBox.setDefaults({
  closeOnClickModal: false
})
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js